import { FC, useRef } from 'react';
import isNil from 'lodash/isNil';
import isEmpty from 'lodash/isEmpty';
import styled from 'styled-components';

import { themeColor, THEME_MUTED } from '../../../styles/basics/colors';

const Icon = styled.i<{ right?: number }>`
    position: absolute;
    margin: 3px;
    height: inherit;
    right: ${props => (props.right ? 'initial' : props.right)};
`;

const StyledInput = styled.input`
    && {
        padding: 3px 20px;
        box-shadow: initial;
        border-bottom: 1px solid ${themeColor(THEME_MUTED)};
        box-sizing: border-box;
    }
`;

interface Props {
    onSearch: (searchTerm: string) => void;
    onClear?: () => void;
}

export const QuickSearchInput: FC<Props> = props => {
    const textInput = useRef<HTMLInputElement>(null);

    function onChange() {
        props.onSearch(textInput.current?.value ?? '');
    }

    function onClear() {
        if (textInput.current) {
            textInput.current.value = '';
        }

        if (props.onClear) {
            onClear();
        }
    }

    return (
        <>
            <Icon className="material-icons md-upper cold-grey">search</Icon>
            <StyledInput className="lc-input" onChange={onChange} placeholder="Search" ref={textInput} type="text" />
            {!isNil(textInput) && !isEmpty(textInput.current?.value) ? (
                <a onClick={onClear}>
                    <Icon right={0} className="material-icons md-upper cold-grey">
                        clear
                    </Icon>
                </a>
            ) : null}
        </>
    );
};
